module.exports = __webpack_public_path__ + "static/media/logo.56906978.svg";